import type { TTestOrderResult } from "@/lib/types";

type IncompleteReason = NonNullable<TTestOrderResult["incompleteReason"]>;

/**
 * Human copy for ADR-0008 incomplete facts shown on the accession tree and
 * result details. Wire codes stay snake_case; UI owns the labels.
 */
export function incompleteReasonSummary(reason: IncompleteReason): string {
  switch (reason) {
    case "pending_dependents":
      return "Waiting on dependent results";
    case "dependents_unavailable":
      return "Dependents unavailable — cancelled or not performed";
    case "empty_dependent_results":
      return "Dependent order is missing result slots";
    default: {
      const _exhaustive: never = reason;
      return _exhaustive;
    }
  }
}

/** Slightly fuller copy for the details dialog. */
export function incompleteReasonDescription(reason: IncompleteReason): string {
  switch (reason) {
    case "pending_dependents":
      return "This result cannot finalize until its dependent reflex results are complete.";
    case "dependents_unavailable":
      return "Required dependents are cancelled or not performed, so reflex cannot finish. Restore cancelled dependents if they should still run, or reconcile once required coverage is satisfied.";
    case "empty_dependent_results":
      return "A dependent order exists but has no result rows yet (incomplete materialization). Reconcile should repair missing slots.";
    default: {
      const _exhaustive: never = reason;
      return _exhaustive;
    }
  }
}
